/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchGroupStatus } from './MatchGroupStatus';
import {
    MatchGroupStatusFromJSON,
    MatchGroupStatusFromJSONTyped,
    MatchGroupStatusToJSON,
    MatchGroupStatusToJSONTyped,
} from './MatchGroupStatus';

/**
 * Request to update match group status
 * @export
 * @interface UpdateMatchGroupStatusRequest
 */
export interface UpdateMatchGroupStatusRequest {
    /**
     * 
     * @type {MatchGroupStatus}
     * @memberof UpdateMatchGroupStatusRequest
     */
    status: MatchGroupStatus;
    /**
     * Optional note about the status change
     * @type {string}
     * @memberof UpdateMatchGroupStatusRequest
     */
    note?: string;
}



/**
 * Check if a given object implements the UpdateMatchGroupStatusRequest interface.
 */
export function instanceOfUpdateMatchGroupStatusRequest(value: object): value is UpdateMatchGroupStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateMatchGroupStatusRequestFromJSON(json: any): UpdateMatchGroupStatusRequest {
    return UpdateMatchGroupStatusRequestFromJSONTyped(json, false);
}

export function UpdateMatchGroupStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMatchGroupStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': MatchGroupStatusFromJSON(json['status']),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdateMatchGroupStatusRequestToJSON(json: any): UpdateMatchGroupStatusRequest {
    return UpdateMatchGroupStatusRequestToJSONTyped(json, false);
}

export function UpdateMatchGroupStatusRequestToJSONTyped(value?: UpdateMatchGroupStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': MatchGroupStatusToJSON(value['status']),
        'note': value['note'],
    };
}

